import OnBoardingLayout from "../OnBoardingLayout.jsx";
import FormContainer from "../../../../components/form/FormContainer.jsx";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import {useContext, useEffect, useState} from "react";
import FormControl from "../../../../components/form/FormControl.jsx";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form/FormButton.jsx";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {ProjectApi} from "../../../../api/authority/generated/index.ts";
import FormError from "../../../../components/form/FormError.jsx";
import {useNavigate} from "react-router-dom";

export default function ProjectStep() {

    let navigate = useNavigate();
    let {t} = useTranslation();
    let {context, getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let existingProject = context.currentUserProjects[0] ?? null;

    let [projectName, setProjectName] = useState('');

    let [creatingState, setDownloading, setResult, setError] = useDownloadState();
    let [createPressed, setCreatePressed] = useState(false);

    useEffect(() => {

        if (existingProject !== null) {
            navigate('/');
        }

        if (!createPressed) {
            return;
        }


        setCreatePressed(false);

        setDownloading(true);
        new ProjectApi(getAuthorityConfiguration())
            .createProject({
                projectInput: {
                    name: projectName
                }
            })
            .then(r => {
                setResult(r);
                resetCurrentUserProjects();
                navigate('/');
            })
            .catch(e => setError(e))
            .finally(() => setDownloading(false));

    }, [createPressed]);

    return (
        <OnBoardingLayout>
            <FormContainer>
                <LoadingComponent loading={creatingState.downloading || createPressed}>
                    {creatingState.error && <FormError error={creatingState.error}/>}
                    <FormControl
                        type={'text'}
                        label={t('project.name')}
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)}
                    />
                    <FormButton
                        className={'button-primary'}
                        onClick={() => setCreatePressed(true)}
                    >
                        {t('project.create')}
                    </FormButton>
                </LoadingComponent>
            </FormContainer>
        </OnBoardingLayout>
    );
}